var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddonAadido(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.12 255.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6fc0f7;}.cls-2{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-addon-a\xF1adido") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_38_copia_9",
    "data-name": "38 copia 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.06,96a14,14,0,0,0-14,14v31.91a13.31,13.31,0,1,0,6.16.2V110a7.84,7.84,0,0,1,7.83-7.83h55.3V96Zm-4.18,58.9a7.12,7.12,0,1,1-7.12-7.12A7.12,7.12,0,0,1,185.88,154.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.63,115.24H58.46a13.28,13.28,0,1,0,0,6.16H96.63a7.84,7.84,0,0,1,7.83,7.83V245.36h6.16V129.23A14,14,0,0,0,96.63,115.24Zm-51.07,10.2a7.12,7.12,0,1,1,7.12-7.12A7.12,7.12,0,0,1,45.56,125.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.34,54.51a13.3,13.3,0,0,0-12.91,10.2H9.75v6.16H84.43A13.28,13.28,0,1,0,97.34,54.51Zm0,20.4a7.12,7.12,0,1,1,7.12-7.12A7.12,7.12,0,0,1,97.34,74.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.78,67.69a13.28,13.28,0,1,0-12.91-16.36H143.48a14,14,0,0,0-14,14v180h6.16v-180a7.85,7.85,0,0,1,7.84-7.84h37.39A13.29,13.29,0,0,0,193.78,67.69Zm0-20.4a7.12,7.12,0,1,1-7.13,7.12A7.14,7.14,0,0,1,193.78,47.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.87,116.2a13.28,13.28,0,0,0-3.08,26.19v40.47A7.84,7.84,0,0,1,206,190.7H181.59a14,14,0,0,0-14,14v40.67h6.16V204.69a7.84,7.84,0,0,1,7.83-7.83H206a14,14,0,0,0,14-14V142.39a13.27,13.27,0,0,0-3.08-26.19Zm0,20.41a7.13,7.13,0,1,1,7.13-7.13A7.14,7.14,0,0,1,216.87,136.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.44,204.16V172.35a14,14,0,0,0-14-14H9.75v6.16h60.7a7.84,7.84,0,0,1,7.83,7.83v31.81a13.28,13.28,0,1,0,6.16,0Zm-3.08,20a7.13,7.13,0,1,1,7.12-7.12A7.13,7.13,0,0,1,81.36,224.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.5,9.75a18.86,18.86,0,0,1,18.86,18.86V226.5a18.85,18.85,0,0,1-18.86,18.86H28.61A18.86,18.86,0,0,1,9.75,226.5V28.61A18.87,18.87,0,0,1,28.61,9.75H226.5m0-9.75H28.61A28.65,28.65,0,0,0,0,28.61V226.5a28.65,28.65,0,0,0,28.61,28.62H226.5a28.65,28.65,0,0,0,28.62-28.62V28.61A28.65,28.65,0,0,0,226.5,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddonAadido);
export default __webpack_public_path__ + "static/media/ic-addon-añadido.63fa4500d94cc59b72afaa6311ba256d.svg";
export { ForwardRef as ReactComponent };